const features = [
  { icon: 'ri-handshake-line', label: 'Expert Consulting' },
  { icon: 'ri-global-line', label: 'Extensive Industry Connections' },
  { icon: 'ri-archive-line', label: 'Reliable Inventory' },
  { icon: 'ri-money-dollar-circle-line', label: 'Competitive Pricing' },
];

const LOGO =
  'https://storage.readdy-site.link/project_files/ef2cd86a-0c8c-43d9-a80f-76980d5cdfeb/efd1c1b3-eb7c-4977-9e9d-97ff5b41d004_OnPoint-Logo-Red-White-and-Blue.png?v=a3ea8d6e61ccf94fd7ba238e66b5c0b3';

export default function WhoWeAre() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative py-24 px-6 overflow-hidden" style={{ background: '#f0f4ff' }}>

      {/* ── Watermark layer ── */}
      {/* Giant centred logo — DNA strands shine through */}
      <img
        src={LOGO}
        alt=""
        aria-hidden="true"
        className="pointer-events-none select-none absolute inset-0 m-auto"
        style={{
          width: '780px',
          maxWidth: '90vw',
          opacity: 0.08,
          filter: 'blur(0px) saturate(2)',
          transform: 'rotate(-6deg)',
          mixBlendMode: 'multiply',
          zIndex: 0,
        }}
      />
      {/* Top-left echo — smaller, rotated differently */}
      <img
        src={LOGO}
        alt=""
        aria-hidden="true"
        className="pointer-events-none select-none absolute -top-16 -left-20"
        style={{
          width: '420px',
          opacity: 0.05,
          filter: 'saturate(3)',
          transform: 'rotate(12deg)',
          mixBlendMode: 'multiply',
          zIndex: 0,
        }}
      />
      {/* Bottom-right echo */}
      <img
        src={LOGO}
        alt=""
        aria-hidden="true"
        className="pointer-events-none select-none absolute -bottom-20 -right-16"
        style={{
          width: '460px',
          opacity: 0.06,
          filter: 'saturate(3)',
          transform: 'rotate(-15deg)',
          mixBlendMode: 'multiply',
          zIndex: 0,
        }}
      />

      {/* ── Foreground content ── */}
      <div className="relative z-10 max-w-7xl mx-auto grid md:grid-cols-2 gap-16 items-center">

        {/* Image column — logo shown large + crisp as focal watermark art */}
        <div className="flex justify-center">
          <div className="relative w-full max-w-md">
            {/* Photo frame */}
            <div className="w-full h-[420px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20medical%20consultant%20with%20confident%20smile%20in%20modern%20clinic%20office%20setting%2C%20regenerative%20medicine%20specialist%2C%20business%20casual%20attire%2C%20bright%20modern%20office%20with%20advanced%20medical%20equipment%20in%20background%2C%20warm%20natural%20lighting%2C%20bokeh%20effect%2C%20clean%20white%20walls%2C%20very%20professional&width=400&height=420&seq=2&orientation=portrait"
                alt="Who We Are - OnPoint USA"
                className="w-full h-full object-cover object-top"
              />
            </div>

            {/* Logo badge card — crisp, clearly visible watermark on top of image */}
            <div
              className="absolute -bottom-6 -right-6 rounded-xl p-4 flex flex-col items-center justify-center"
              style={{
                background: 'rgba(0,40,104,0.92)',
                backdropFilter: 'blur(8px)',
                width: '148px',
                boxShadow: '0 4px 24px 0 rgba(0,40,104,0.22)',
              }}
            >
              <img src={LOGO} alt="OnPoint USA" className="w-24 mb-2" style={{ filter: 'brightness(1.1)' }} />
              <span className="text-blue-200 text-xs font-semibold tracking-wide">10+ Years</span>
              <span className="text-white text-xs tracking-wide">Regen Medicine</span>
            </div>

            {/* DNA accent pill top-left */}
            <div
              className="absolute -top-4 -left-4 flex items-center gap-2 rounded-full px-4 py-2"
              style={{ background: '#dc2626', boxShadow: '0 2px 12px rgba(220,38,38,0.35)' }}
            >
              <i className="ri-dna-fill text-white text-sm" />
              <span className="text-white text-xs font-bold whitespace-nowrap">Regenerative Medicine</span>
            </div>
          </div>
        </div>

        {/* Content */}
        <div>
          <div className="flex items-center gap-3 mb-3">
            <span className="w-8 h-0.5 bg-red-500 inline-block" />
            <p className="text-red-600 text-sm font-semibold uppercase tracking-widest">Who we are</p>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-5" style={{ fontFamily: "'Playfair Display', serif" }}>
            OnPoint USA
          </h2>
          <p className="text-gray-700 leading-relaxed mb-4 text-sm">
            With over <strong>10 years of dedicated experience</strong> in the Regenerative Medicine field, OnPoint USA stands as a trusted authority for healthcare professionals, medical spas, clinics, and distributors. Our team brings unmatched expertise and a vast network of industry connections to every partnership.
          </p>
          <p className="text-gray-700 leading-relaxed mb-8 text-sm">
            We leverage our extensive relationships across the Regenerative Medicine landscape to connect our partners with the right resources, the right people, and the right solutions — so you can focus on what matters most: delivering exceptional patient outcomes.
          </p>

          <ul className="space-y-3 mb-10">
            {features.map((f) => (
              <li key={f.label} className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-red-50">
                  <i className={`${f.icon} text-red-600 text-base`} />
                </div>
                <span className="text-gray-700 text-sm font-medium">{f.label}</span>
              </li>
            ))}
          </ul>

          <button
            onClick={() => handleNav('#services')}
            className="px-7 py-3 bg-red-600 text-white font-semibold rounded-md hover:bg-red-700 transition-colors cursor-pointer whitespace-nowrap text-sm"
          >
            View Our Services
          </button>
        </div>
      </div>
    </section>
  );
}
